import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Heading, Icon, Separator, Table, TableRow, TableCell } from 'telia-front-react';
export const InternetDescription = (props) => {
    const { offer } = props;
    const { isMobile } = useIsMobileHook();
    const { translate } = React.useContext(TranslationsContext);
    const renderTableCell = (width, padding, content, className) => (React.createElement(TableCell, { padding: padding, valign: "middle", width: width, className: className },
        isMobile && React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
        content,
        isMobile && React.createElement(Separator, { color: "invisible", spacing: "xxsmall" })));
    const renderTableRow = (detailIcon, detailName, detailValue) => (React.createElement(TableRow, null,
        !isMobile && renderTableCell(1, 'none', React.createElement(Icon, { modifiers: `#${detailIcon}`, size: "sm" })),
        renderTableCell(isMobile ? 6 : 5, isMobile ? 'none' : 'default', translate(`internetCalculator.details.description.${detailName}`)),
        renderTableCell(6, 'none', React.createElement("strong", null, detailValue), 'text-right')));
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: 1, className: "h4 text-bold" }, translate('internetCalculator.details.description.title')),
        React.createElement(Separator, { spacing: "xxsmall", color: "strong", weight: "thin" }),
        React.createElement(Table, null,
            React.createElement("tbody", null,
                renderTableRow('service-internet', 'internetType', translate(`internetCalculator.details.description.type.${offer.technology}`)),
                renderTableRow('arrow-download', 'download', translate('internetCalculator.details.description.downloadValue', {
                    value: offer.downloadSpeed,
                })),
                renderTableRow('arrow-upload', 'upload', translate('internetCalculator.details.description.uploadValue', {
                    value: offer.uploadSpeed,
                })))),
        React.createElement(Separator, { spacing: "xxsmall", weight: "thin" }),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" })));
};
